import { useContext, useState, useEffect } from "react";
import MenuButton from "../menuButton/MenuButton.component";
import { menuData } from "../../../data/MenuData";
import logoutIcon from "../../../assets/icon_logout.svg";
import logoutIconWhite from "../../../assets/icon_logout_white.svg";
import { UserContext } from "../../../context/UserContext.component";
import defaultUserImage from "../../../assets/default_user_image.png";
import { fetchUserData } from "./userApi";
import { Logout } from "../../../api/apiLogout";

const Sidebar = () => {
  const { dispatch } = useContext(UserContext);
  const [accountData, setAccountData] = useState(null);
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  const [activeParentMenuItem, setActiveParentMenuItem] = useState(null);
  const [isParentHovered, setIsParentHovered] = useState(false);
  const token = sessionStorage.getItem("token");

  const handleLogout = async () => {
    await Logout(dispatch);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseData = await fetchUserData(token);
        setAccountData(responseData.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [token]);

  return (
    <div className="h-full  hidden md:block w-[265px] font-rubik">
      <div className="bottom-0  font-semibold w-[265px] h-full  bg-white flex flex-col items-center border-t-0 shadow-lg border-r ">
        <img
          src={
            accountData && accountData.profile_picture
              ? accountData.profile_picture
              : defaultUserImage
          }
          className="w-[111px] rounded-[50%] mt-11"
          alt="user_image"
        />
        {accountData && accountData.first_name && accountData.last_name ? (
          <p className="mt-5 font-medium">
            {accountData.first_name} {accountData.last_name}
          </p>
        ) : (
          <p className="mt-5 font-medium text-gray-400">Loading...</p>
        )}

        <div className="mt-6 w-[100%] text-left">
          {menuData.map((menuItem) => (
            <MenuButton
              key={menuItem.id}
              menuItem={menuItem}
              setActiveMenuItem={setActiveMenuItem}
              activeMenuItem={activeMenuItem}
              setActiveParentMenuItem={setActiveParentMenuItem}
              activeParentMenuItem={activeParentMenuItem}
              isMobile={false}
            />
          ))}
        </div>
        <div
          className={`border border-r-0 py-5 hover:bg-primary-1 hover:text-white cursor-pointer my-5 flex items-center justify-center gap-2 w-full font-medium`}
          style={{ marginTop: "auto", marginBottom: "36px" }}
          onClick={handleLogout}
          onMouseEnter={() => setIsParentHovered(true)}
          onMouseLeave={() => setIsParentHovered(false)}
        >
          <img
            src={isParentHovered ? logoutIconWhite : logoutIcon}
            alt="logout button"
            className="fill-current primary-1 hover:text-white"
          />
          Logout
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
